import React, {Component} from 'react';
import {observer} from "mobx-react";
import GridGallery from "../../Helpers/GridGallery/GridGallery";
import Aspect from "../../Helpers/Aspect";
import LazyBg from "../../Helpers/LazyBg";
import AttachmentSpoiler from "./AttachmentSpoiler";
import LazyBlock from "../../Helpers/LazyBlock";
import LazyImg from "../../Helpers/LazyImg";
import uid from "../../../utils/generateUid";
import webp from "../../../utils/webp";

class Image extends Component {
  getImgOb()
  {
    return {
      width: this.props.data.item.media[0].gif.dims[0],
      height: this.props.data.item.media[0].gif.dims[1],
    }
  }
  render() {
    if(!this.props.data || !this.props.data.item) {
      return null;
    }
    if(this.props.data.spoiler && !this.props.data.show_spoiler) {
      return (
        <AttachmentSpoiler data={this.props.data} />
      )
    }

    return (
      <div style={{maxWidth:'100%', width: 400}} className="center pr">
        <Aspect pa={true} className="bg-w2" img={this.getImgOb()} resizedCode={"600x600"}>
          <LazyImg
            hiddenClassName="w100 h100"
            src={this.props.data.item.media[0].gif.url}
            className="db mw100 rad4"
          />
        </Aspect>
        {/*
        <Aspect pa={true} className="bg-w2" aspect={`${this.props.data.height}:${this.props.data.width}`}>
                  <LazyBg className="w100 h100" style={{backgroundPosition:'top center',backgroundSize:'cover',backgroundImage:`url('/autoresize/600x600${this.props.data.image}')`}}/>
                </Aspect>
        <img src={this.props.data.image} />
        */}
      </div>
    )
  }
}

export default observer(Image);